export const pointsOrCashback = {
  data: () => ({
    path: '',
  }),
  computed: {
    pointsText() {
      if (!this.path) return ''
      return this.path === '/mobile/historico-vouchers' ? 'pontos' : 'cashback'
    },
  },
  mounted() {
    const { path } = this.$route
    this.path = path
  },
}
